import { createFileRoute, redirect } from "@tanstack/react-router";
import i18n from "@modules/shared/localization/i18n";
import { seo } from "@utils/seo";

export const Route = createFileRoute("/$locale/_layout/(protected)/_protected")(
  {
    ssr: true,
    async beforeLoad({ context, params }) {
      const isAuthenticated = context.isAuthenticated();
      if (!isAuthenticated) {
        throw redirect({
          to: "/$locale/login",
          params: {
            locale: params.locale,
          },
        });
      }
    },
    headers: () => ({
      "Cache-Control": "private, no-store",
    }),
    head: ({ params }) => {
      const t = i18n.getFixedT(params.locale);

      return {
        meta: [
          ...seo({
            title: t("Seo:account.title"),
            description: t("Seo:account.description"),
            robots: "noindex, nofollow",
          }),
        ],
      };
    },
  },
);
